export class Data {
	static Object<Type extends object>(owner: Data, field: string, value: new (value?: object) => Type): Type {
		return (owner as any)[Data.value] ? new value((owner as any)[Data.value][field]) : new value
	}

	static Array<Type>(owner: Data, field: string): Type[] {
		return (owner as any)[Data.value] ? (owner as any)[Data.value][field] as Type[] : [] as Type[]
	}

	static String(owner: Data, field?: string): string {
		return (owner as any)[Data.value] ? (owner as any)[Data.value][field] : ""
	}

	static Number(owner: Data, field?: string): number {
		return (owner as any)[Data.value] ? (owner as any)[Data.value][field] : 0
	}

	static Boolean(owner: Data, field?: string): boolean {
		return (owner as any)[Data.value] ? (owner as any)[Data.value][field] : false
	}

	constructor(value?: object) {
		if (value) (this as any)[Data.value] = value
	}

	private static value = Symbol()
}
